import React from 'react';
import { CheckoutTabHeaderMolecule } from '../../molecules';
import { useCheckoutStyles } from '../../../styles/templates/checkout.styles';
import { PatientStepsHeader } from '../../../data/pages/checkout/patient-steps.data';
import { CheckoutButtons } from '../../../enums/pages/checkout/checkout-buttons';
import { usePatientEffect } from '../../../effects';
import { Route } from '../../../enums';

export const PatientRegisterStepOrganism = () => {
  const classes = useCheckoutStyles();
  const { patientRegistrationFormState, onSubmitPatient } =
    usePatientEffect('registration');

  return (
    <div
      data-cy="checkout-register-step-organism"
      className={`bg-white py-5 lg:py-0 ${classes.checkout}`}
    >
      <CheckoutTabHeaderMolecule
        title={PatientStepsHeader.DOCTOR}
        editable={true}
        editLink={Route.PATIENT_DOCTOR}
      />

      <div className="pb-8 w-11/12 lg:w-full mx-auto border-b border-waldo-blue">
        <h1 className="text-tabTitle font-normal font-waldo-regular no-underline">
          {PatientStepsHeader.REGISTER}
        </h1>
        <div className="relative">
          <label htmlFor="customer-email" className="hidden" />
          <input
            className={`${
              !patientRegistrationFormState.members.email.isClean &&
              !patientRegistrationFormState.members.email.isValid &&
              'input-error-border'
            }`}
            type="email"
            id="customer-email"
            placeholder="Email"
            onChange={(e) =>
              patientRegistrationFormState.members.email.onChange(
                e.target.value
              )
            }
            onFocus={() => patientRegistrationFormState.members.email.onFocus()}
            onBlur={() => patientRegistrationFormState.members.email.onBlur()}
            value={patientRegistrationFormState.members.email.value as string}
          />
          {!patientRegistrationFormState.members.email.isClean &&
            !patientRegistrationFormState.members.email.isValid &&
            patientRegistrationFormState.members.email.errors.length > 0 && (
              <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                <div className="error-icon"></div>
                {patientRegistrationFormState.members.email.errors[0]}
              </div>
            )}
        </div>
        <div className="relative mt-1.5">
          <label htmlFor="customer-password" className="hidden" />
          <input
            className={`${
              !patientRegistrationFormState.members.password.isClean &&
              !patientRegistrationFormState.members.password.isValid &&
              'input-error-border'
            }`}
            type="password"
            id="customer-password"
            placeholder="Password"
            onChange={(e) =>
              patientRegistrationFormState.members.password.onChange(
                e.target.value
              )
            }
            onFocus={() =>
              patientRegistrationFormState.members.password.onFocus()
            }
            onBlur={() =>
              patientRegistrationFormState.members.password.onBlur()
            }
            value={
              patientRegistrationFormState.members.password.value as string
            }
          />
          {!patientRegistrationFormState.members.password.isClean &&
            !patientRegistrationFormState.members.password.isValid &&
            patientRegistrationFormState.members.password.errors.length > 0 && (
              <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                <div className="error-icon"></div>
                {patientRegistrationFormState.members.password.errors[0]}
              </div>
            )}
        </div>
        <div className="relative mt-1.5">
          <label htmlFor="customer-repeat-password" className="hidden" />
          <input
            className={`${
              !patientRegistrationFormState.members.passwordConfirm.isClean &&
              !patientRegistrationFormState.members.passwordConfirm.isValid &&
              'input-error-border'
            }`}
            type="password"
            id="customer-repeat-password"
            placeholder="Repeat password"
            onChange={(e) =>
              patientRegistrationFormState.members.passwordConfirm.onChange(
                e.target.value,
                patientRegistrationFormState.members.password.value
              )
            }
            onFocus={() =>
              patientRegistrationFormState.members.passwordConfirm.onFocus()
            }
            onBlur={() =>
              patientRegistrationFormState.members.passwordConfirm.onBlur()
            }
            value={
              patientRegistrationFormState.members.passwordConfirm
                .value as string
            }
          />
          {!patientRegistrationFormState.members.passwordConfirm.isClean &&
            !patientRegistrationFormState.members.passwordConfirm.isValid &&
            patientRegistrationFormState.members.passwordConfirm.errors.length >
              0 && (
              <div className="absolute -bottom-1 text-sm text-waldo-tangerine left-5">
                <div className="error-icon"></div>
                {patientRegistrationFormState.members.passwordConfirm.errors[0]}
              </div>
            )}
        </div>
        <div className="flex flex-col items-center w-full py-5 lg:py-1">
          <button
            disabled={!patientRegistrationFormState.isValidRegistration}
            className="button btn-third-cta w-80 md:w-[203px] mt-3 text-uppercase font-waldo-header font-medium text-base"
            onClick={() => onSubmitPatient()}
          >
            <>{CheckoutButtons.NEXT_STEP}</>
          </button>
        </div>
      </div>
      <div className="w-11/12 lg:w-full mx-auto">
        <CheckoutTabHeaderMolecule title={PatientStepsHeader.PLAN} />
        <CheckoutTabHeaderMolecule title={PatientStepsHeader.PRESCRIPTION} />
        <CheckoutTabHeaderMolecule title={PatientStepsHeader.SHIPPING} />
        <CheckoutTabHeaderMolecule title={PatientStepsHeader.REVIEW} />
        <CheckoutTabHeaderMolecule
          title={PatientStepsHeader.PAYMENT}
          displayBorder={false}
        />
      </div>
    </div>
  );
};
